<template>
    <div class="map-wrapper">
        <div id="map" class="map"></div>

        <form
            action=""
            method=""
            @submit.prevent
         >
            <input type="hidden" name="_token" :value="csrfToken">

            <div class="form-group map-search-group">
                <input
                    @input="this.getMarkers"
                    v-model="input"
                    type="text"
                    class="form-control map-search-input"
                    id="mapInput"
                    :placeholder="$t('store.search_placeholder')"
                    required
                >
                <label for="mapInput">{{ $t('store.search_placeholder') }}</label>
                <search-icon class="map-search-icon" />
            </div>
        </form>

        <spinner v-if="isLoading" size="small" />

        <div class="map-content">
            <div v-if="markers.length">
                <transition-group name="fade">
                    <div
                        v-for="(marker, index) in markers"
                        :key="marker.id"
                        :class="[{ 'mb-2': index !== markers.length - 1 }, 'map-content-item']"
                    >
                        <h4>{{ marker.title }}</h4>
                        <address>
                            {{ marker.address }}<br>
                            {{ marker.zip }} {{ marker.city }}<br>
                            {{ marker.country }}<br>
                            T: {{ marker.phone }}
                        </address>

                        <a :href="marker.url" class="d-block mt-2">{{ $t('store.more_info') }}</a>
                    </div>
                </transition-group>
            </div>
            <p v-else class="text-center">{{ $t('store.stores_non_found') }}</p>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { SearchIcon } from 'vue-feather-icons';
    import Spinner from '@/_vue/components/ui/spinner';

    export default {
        name: 'Stores',
        components: {
            SearchIcon,
            Spinner,
        },
        data() {
            return {
                center: {
                    lat: 52.0852664,
                    lng: 4.3114043,
                },
                isLoading: false,
                input: '',
                inputTimeout: null,
                map: null,
                markers: [],
                markersGoogleMaps: [],
                zoom: 10,
            };
        },
        props: {
            url: {
                type: String,
                required: true,
            },
        },
        mounted() {
            this.initializeMap();
            this.getMarkers();
        },
        methods: {
            initializeMap() {
                this.map = new google.maps.Map(document.getElementById('map'), {
                    center: this.center,
                    zoom: this.zoom,
                });
            },

            getMarkers() {
                clearTimeout(this.inputTimeout);

                this.inputTimeout = setTimeout(() => {
                    this.isLoading = true;
                    this.removeMarkers();

                    axios.get(this.url, { params: { q: this.input } })
                        .then((response) => {
                            this.markers = response.data.markers;
                            this.setMapMarkers();
                        })
                        .catch((error) => {
                            window.Feedback.feedbackLoad({ closeable: true, message: error });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }, 300);
            },

            removeMarkers() {
                this.markers = [];
                this.markersGoogleMaps.forEach(marker => marker.setMap(null));
                this.markersGoogleMaps = [];
            },

            setMapMarkers() {
                this.bounds = new google.maps.LatLngBounds();

                this.infoWindow = new google.maps.InfoWindow({
                    maxWidth: 200,
                    pixelOffset: new google.maps.Size(0, -3),
                });

                this.markers.forEach((markerData) => {
                    const markerDataLatLng = new google.maps.LatLng(markerData.lat, markerData.lng);
                    const marker = new google.maps.Marker({
                        position: markerDataLatLng,
                        map: this.map,
                        title: markerData.title,
                        markerId: markerData.id,
                        url: markerData.url,
                    });

                    marker.addListener('click', () => {
                        window.location = marker.url;
                    });

                    marker.addListener('mouseover', () => {
                        this.infoWindow.open(this.map, marker);
                        this.infoWindow.setContent(`<a href="${marker.url}">${marker.title}</a>`);
                    });

                    this.markersGoogleMaps.push(marker);
                    this.bounds.extend(markerDataLatLng);
                });

                this.setMapView();
            },

            setMapView() {
                this.map.fitBounds(this.bounds);

                if (!this.markers.length) {
                    this.map.setCenter(this.center);
                    this.map.setZoom(this.zoom);
                }
            },
        },
    };
</script>
